import { i18n } from '@fs/zion-locale'
import { baseUrl } from '@fs/zion-config'
import generateCitationData from './generateCitationData'

const generateCitation = ({
  creator,
  createdDate,
  custodian,
  place,
  location,
  imageIndex,
  imageCount,
  queryView,
  imageGroupNumber,
}) => {
  const { coverageString, currentDateFormatted, imageCitation, custodianString, ark } = generateCitationData({
    creator,
    createdDate,
    custodian,
    place,
    location,
    imageIndex,
    imageCount,
  })

  const mainCitation = `${coverageString} ${i18n.t('generateCitation.images', 'images')}, ${i18n.t(
    'generateCitation.familySearch',
    'FamilySearch'
  )} (${baseUrl}/ark:/61903/${ark}?view=${queryView}${
    currentDateFormatted ? ` : ${currentDateFormatted}` : ''
  }), ${imageCitation}; ${custodianString}.`

  // Add image group number if it exists
  return imageGroupNumber
    ? `${mainCitation}\n${i18n.t('generateCitation.imageGroupNumber', 'Image Group Number')}: ${imageGroupNumber}`
    : mainCitation
}

export default generateCitation
